import { useState, useEffect } from "react";
import { TextField, Box, Button, CardMedia, Card } from "@mui/material";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseHeader } from "./UseHeader";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import { useSnackbar } from "notistack";
import TopBanner from "./TopBanner";
import { readFromLS } from "../../../util/LocalStrogeService";

export default function HeaderManage() {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const navigate = useNavigate();
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { GetHeader, SetHeader } = UseHeader();
  const [homePageId, setHomePageid] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : ""
  );
  const [state, setState] = useState({
    id: undefined,
    urL1: "/",
    urL2: "/",
    urL3: "/",
    headerID: homePageId ? homePageId.id : 1,
  });
  const [imgState, setImgState] = useState({
    imageFile1: undefined,
    imageUrl1: undefined,
    imageFile2: undefined,
    imageUrl2: undefined,
    imageFile3: undefined,
    imageUrl3: undefined,
  });

  const handleChangeImage1 = (file) => {
    setImgState({
      ...imgState,
      imageFile1: file[0],
      imageUrl1: URL.createObjectURL(file[0]),
    });
  };

  const handleChangeImage2 = (file) => {
    setImgState({
      ...imgState,
      imageFile2: file[0],
      imageUrl2: URL.createObjectURL(file[0]),
    });
  };

  const handleChangeImage3 = (file) => {
    setImgState({
      ...imgState,
      imageFile3: file[0],
      imageUrl3: URL.createObjectURL(file[0]),
    });
  };
  useEffect(() => {
    setProgress(true);
    GetHeader(
      homePageId?.id ? homePageId.id : 1,
      (header) => {
        setImgState({
          ...imgState,
          imageUrl1: header.logo1 ? header.logo1 : "",
          imageUrl2: header.logo2 ? header.logo2 : "",
          imageUrl3: header.logo3 ? header.logo3 : "",
        });
        setState({
          id: header.id ? header.id : "",
          urL1: header.urL1 ? header.urL1 : "",
          urL2: header.urL2 ? header.urL2 : "",
          urL3: header.urL3 ? header.urL3 : "",
          headerID: homePageId ? homePageId.id : 1,
        });
      },
      true
    );
  }, []);

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/homepagemanage" },
          {
            name: "مدیریت هدر",
            url: "/headerManage",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 3 }}
          gridColumn="span 12"
        >
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage1(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "120px", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    bgcolor: "#e0e0e0",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl1
                        ? imgState.imageUrl1
                        : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
          <TextField
            // fullWidth
            sx={{
              width: "40%",
              textarea: { direction: "rtl" },
            }}
            multiline
            maxRows={4}
            value={state.urL1 ? state.urL1 : ""}
            // error={errorState.urL1}
            label="لینک تصویر"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, urL1: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 3 }}
          gridColumn="span 12"
        >
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage2(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "120px", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    bgcolor: "#e0e0e0",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl2
                        ? imgState.imageUrl2
                        : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
          <TextField
            // fullWidth
            sx={{
              width: "40%",
              textarea: { direction: "rtl" },
            }}
            multiline
            maxRows={4}
            value={state.urL2 ? state.urL2 : ""}
            // error={errorState.urL1}
            label="لینک تصویر"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, urL2: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 3 }}
          gridColumn="span 12"
        >
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage3(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "120px", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    bgcolor: "#e0e0e0",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl3
                        ? imgState.imageUrl3
                        : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
          <TextField
            // fullWidth
            sx={{
              width: "40%",
              textarea: { direction: "rtl" },
            }}
            multiline
            maxRows={4}
            value={state.urL3 ? state.urL3 : ""}
            // error={errorState.urL3}
            label="لینک تصویر"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, urL3: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </Box>

      <Box
        gridColumn="span 12"
        sx={{ my: 2, display: "flex", justifyContent: "center" }}
      >
        <Button
          sx={{ mr: 2, width: "100px" }}
          variant="contained"
          onClick={() => {
            //   if (validateItem(state, setErrorState) == 200) {
            setProgress(true);
            SetHeader(
              state,
              imgState.imageFile1,
              imgState.imageFile2,
              imgState.imageFile3,
              (calback) => {
                navigate("/homepagemanage", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }
            );
            //   }
          }}
        >
          ثبت
        </Button>
        <Button
          sx={{ width: "100px" }}
          variant="outlined"
          color="secondary"
          onClick={() => {
            navigate("/homepagemanage", {
              state: { ...location.state, isBack: true },
              replace: true,
            });
          }}
        >
          بازگشت
        </Button>
      </Box>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box sx={{ my: 2 }} gridColumn="span 12">
          <Link
            target="_blank"
            to={{
              pathname: "/menues",
            }}
          >
            <Button variant="contained" color="secondary">
              مدیریت منوها
            </Button>
          </Link>
        </Box>
      </Box>
      <TopBanner />
    </Detail>
  );
}
